module.exports = __webpack_public_path__ + "img/moncash_menu.b4577db0.svg";